import React, { useContext } from "react";
import Constants from "../../services/constants";
import { ReactComponent as Logo1 } from "../../assets/logo-day.svg";
import TwitterLogo from "../../assets/logo/twitter_logo.gif"
import XLogo from "../../assets/logo/x_logo.png"
import FacebookLogo from "../../assets/logo/facebookLogo.png"
import YoutubeLogo from "../../assets/logo/youtube-icon.png"
import InstaLogo from "../../assets/logo/instaLogo.png"
import TrackContext from "../../contexts/track-context";

export default function Footer() {
  const trackContext = useContext(TrackContext);
    
  return (
    <div
      className="footer-wrapper px-2"
      // style={{ fontSize: "14px", fontWeight: "100", fontFamily: "Synthese" }}
    >
      <div className="border-t mb-2 hidden lg:block"></div>
      <div className=" flex justify-between flex-col sm:flex sm:w-full sm:flex-no-wrap  flex-wrap ">
        {/* <div className="flex justify-between sm:flex sm:flex-wrap text-xds lg:text-sm">
          <div className="mb-2  sm:mr-32 flex justify-start text-left ">
            <ul>
            
              <li className="pb-1">
                <a href={`/terms`}>Terms of Service</a>
              </li>
              <li className="pb-1">
                <a href={`/privacy`}>Privacy Policy</a>
              </li>
              <li className="pb-1">
                <a href={`/cookies`}>Cookie Policy</a>
              </li>
            </ul>
          </div>
          <div className="mb-10 flex justify-start text-left">
            <ul>
            <li className="pb-1">
                <a href={`/about`}>About Us</a>
              </li>
              <li className="pb-1">
                <a href={`/contact`}>Contact Us</a>
              </li>
              <li className="pb-1">
                <a href={`/faqs`}>FAQ's</a>
              </li>
            </ul>
          </div>
        </div> */}

        <div className="w-full flex">
            <div className="w-full flex flex-wrap  gap-y-2 lg:gap-y-0 rounded-2xl px-4 md:px-10  lg:px-20 py-4 sm:justify-center shadow-box t-artist" style={{background : "rgb(var(--bg))"}}>
                <span className="w-1/2 md:w-1/3 lg:w-2/12 flex justify-center">
                    <a className="w-full flex justify-center" href={`/about`}>ABOUT US</a>
                </span>
                <span className="w-1/2 md:w-1/3 lg:w-2/12 flex justify-center">
                    <a className="w-full flex justify-center" href={`/terms`}>TERMS OF SERVICE</a>
                </span>
                <span className="w-1/2 md:w-1/3 lg:w-2/12 flex justify-center">
                    <a className="w-full flex justify-center" href={`/privacy`}>PRIVACY POLICY</a>
                </span>
                <span className="w-1/2 md:w-1/3 lg:w-2/12 flex justify-center">
                    <a className="w-full flex justify-center" href={`/cookies`}>COOKIE POLICY</a>
                </span>
                <span className="w-1/2 md:w-1/3 lg:w-2/12 flex justify-center">
                    <a className="w-full flex justify-center" href={`/faqs`}>FAQS</a>
                </span>
                <span className="w-1/2 md:w-1/3 lg:w-2/12 flex justify-center">
                    <a className="w-full flex justify-center" href={`/contact`}>CONTACT US</a>
                </span>
            </div>
        </div>
        {!trackContext.userSignedIn &&
        <div className="w-full flex justify-end flex-row flex-1">
          {/* <div className="sm:flex sm:justify-end mb-6 flex justify-center">
            <Logo1 alt="brand-logo" />
          </div> */}
          <div className="sm:flex sm:justify-end my-1 flex justify-center">
            {/* <div className="mr-3">
              <a href={Constants.SM_TWITTER_LINK} target="_blank">
                <img
                  src={XLogo}
                  alt="logo"
                  className="h-8"
                  title="Twitter"
                />
              </a>
            </div> */}
            <div className="mr-3">
              <a href={Constants.SM_FACEBOOK_LINK} target="_blank">
                <img
                  src={FacebookLogo}
                  alt="logo"
                  className="h-8"
                  title="Facebook"
                />
              </a>
            </div>
            <div className="mr-3">
              <a href={Constants.SM_YOUTUBE_LINK} target="_blank">
                <img
                  src={YoutubeLogo}
                  alt="logo"
                  className="h-8"
                  title="Youtube"
                />
              </a>
            </div>
            <div className="">
              <a href={Constants.SM_INSTA_LINK} target="_blank">
                <img
                  src={InstaLogo}
                  alt="logo"
                  className="h-8"
                  title="Instagram"
                />
              </a>
            </div>
          </div>
        </div>}
      </div>
      <div className="text-center warn-text sm:mt-4 " style={{ color: "#999999" }}>
        ©{new Date().getFullYear()} SyncMama. All rights reserved.
      </div>
    </div>
  );
}
